import { tokensToCss } from 'styles/tokens';

const STYLE_ID = 'theme-tokens';

// Idempotent: the provider may remount (tests, hot reload) but the variables are defined once.
export const injectTokenStyles = () => {
  if (document.getElementById(STYLE_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = tokensToCss();
  document.head.appendChild(style);
};
